import { render, staticRenderFns } from "./MultiselectWidget.vue?vue&type=template&id=4f436b2b"
import script from "./MultiselectWidget.vue?vue&type=script&lang=js"
export * from "./MultiselectWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports